import { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { API } from '../App';

const InviteFamilyModal = ({ client, onClose }) => {
  const [email, setEmail] = useState('');
  const [name, setName] = useState('');
  const [sending, setSending] = useState(false);
  const [result, setResult] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await axios.post(`${API}/clients/${client.id}/family-invite`, {
        invited_email: email,
        invited_name: name || null,
      });
      setResult(res.data);
      toast.success(`Invite sent to ${email}`);
    } catch (err) {
      toast.error(err?.response?.data?.detail || 'Failed to send invite');
    } finally {
      setSending(false);
    }
  };

  const copyLink = () => {
    if (!result?.magic_link) return;
    navigator.clipboard.writeText(result.magic_link);
    toast.success('Link copied');
  };

  return (
    <div className="welcome-modal-overlay" onClick={onClose} data-testid="invite-family-modal">
      <div className="welcome-modal" onClick={(e) => e.stopPropagation()} style={{ maxWidth: 500 }}>
        <div className="welcome-modal-header">
          <i className="fa-solid fa-envelope-circle-check" style={{ fontSize: '2rem', color: '#2c5364' }}></i>
          <h2>Invite Family</h2>
        </div>
        <p className="welcome-modal-tagline">
          Send <strong>{client.name}</strong>'s family a magic link to follow their daily care. The link expires in 24 hours.
        </p>

        {!result && (
          <form onSubmit={submit} style={{ display: 'flex', flexDirection: 'column', gap: '0.75rem' }}>
            <div className="form-group">
              <label>Family member's name <span style={{ color: '#94a3b8', fontWeight: 400 }}>(optional)</span></label>
              <input type="text" value={name} onChange={(e) => setName(e.target.value)} placeholder="e.g., Sarah" data-testid="invite-name-input" />
            </div>
            <div className="form-group">
              <label>Family member's email</label>
              <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="family@example.com" data-testid="invite-email-input" />
            </div>
            <button type="submit" className="welcome-modal-btn" disabled={sending} data-testid="invite-send-btn">
              {sending ? 'Sending…' : <><i className="fa-solid fa-paper-plane" /> Send Invite</>}
            </button>
          </form>
        )}

        {result && (
          <div data-testid="invite-success">
            <div className="entitlement-banner" style={{ margin: '0 0 1rem 0' }}>
              <i className="fa-solid fa-circle-check" />
              <div>
                <strong>Invite sent to {result.email_sent_to}</strong>
                <div style={{ fontSize: '0.8rem', opacity: 0.85 }}>Expires in 24 hours.</div>
              </div>
            </div>
            <label style={{ fontSize: '0.85rem', color: '#6b8899', fontWeight: 600 }}>Or share this link directly:</label>
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: 6 }}>
              <input readOnly value={result.magic_link} style={{ flex: 1, fontSize: '0.8rem' }} data-testid="invite-link" />
              <button type="button" onClick={copyLink} className="clog-nav-btn primary" style={{ maxWidth: 100, flex: 'unset' }} data-testid="invite-copy-link">
                <i className="fa-solid fa-copy" /> Copy
              </button>
            </div>
            <button className="welcome-modal-btn" onClick={onClose} style={{ marginTop: '1.25rem' }} data-testid="invite-close-btn">Done</button>
          </div>
        )}
      </div>
    </div>
  );
};

export default InviteFamilyModal;
